<template>
  <div class="row">
    <el-dialog
      left
      title="Add Company"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      :showClose="true"
      :visible.sync="isShow"
      width="516px"
      style="margin: 0 auto"
      @close="
        companiesList = [];
        referred_by_tags = [];
        referralInput = '';
        selected = false;
        isNewCompany = false;
      "
      class="diligence-dialog col-lg-12 col-sm-12 col-12 col-md-12"
    >
      <form>
        <div class="row" style="margin-bottom: 15px">
          <div class="col-12">
            <div>
              Company Name
              <span class="required">*</span>
            </div>
            <vue-bootstrap-typeahead
              :data="companiesList"
              v-model="diligenceName"
              v-if="value.isShow"
              class="diligenceAutoCompleteClass"
              :serializer="checkCompany"
              :minMatchingChars="minMatchingChars"
              placeholder="Enter Company Name"
              @hit="onAfterCompanySelection"
            >
              <template slot="suggestion" slot-scope="{ data }">
                <div>
                  <div
                    :class="
                      data && data.duplicate == 'found' ? 'duplicate' : ''
                    "
                  >
                    <div
                      class="dd-icon-wrapper"
                      v-if="
                        data.properties && data.properties.profile_image_url
                      "
                    >
                      <img
                        class="dd-icon"
                        height="30"
                        width="30"
                        :src="getImageUrl(data.properties.profile_image_url)"
                      />
                    </div>
                    {{ data.properties.name }}
                    <span class="gray">{{
                      data.properties.short_description
                    }}</span>
                    <span
                      v-if="data && data.duplicate == 'found'"
                      class="exists"
                      >already exists</span
                    >
                  </div>
                </div>
              </template>
            </vue-bootstrap-typeahead>
          </div>
          <div class="col-12" v-if="diligenceName">
            <div style="padding-left: 15px">
              <div class="addCompanyBodyAnywayDiv">
                If your company is not listed above, you can
                <span
                  class="addCompanyBodyAnywaySpan"
                  @click="addAnyway(diligenceName)"
                  >Add Anyway</span
                >
                for now and we will continue to search “{{ diligenceName }}” in
                the mean time.
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <!-- <div class="col-6">
            <div>Foundind Date</div>
            <input
              type="date"
              class="form-control team-form"
              style="width: 100%;"
              :max="moment().format('YYYY-MM-DD')"
              min="2000-01-01"
              :value="value.data.founding_date && moment.utc(value.data.founding_date).format('YYYY-MM-DD')"
              @input="value.data.founding_date = moment($event.target.valueAsDate)"
              placeholder="Current Cost"
            />
          </div>-->
          <div class="col-12" v-if="isNewCompany">
            <div>Sector</div>
            <vue-single-select
              v-model="value.data.sector"
              placeholder="Select Sector"
              :options="sortedSectors"
              class="form-control sectorVueSingleSelect"
            ></vue-single-select>
          </div>
        </div>
        <!-- <div class="row">
          <div class="col-6">
            <div>Geography</div>
            <input
              type="text"
              v-model="value.data.geography"
              placeholder="Geography"
              class="select-primary form-control team-form"
              id="autocompleteMap"
            />
            <input type="hidden" name="lat" />
            <input type="hidden" name="long" />
          </div>
          <div class="col-6">
            <div>URL</div>
            <input
              id="companyURL"
              v-model="value.data.website"
              class="form-control team-form"
              placeholder="URL"
              type="url"
            />
          </div>
        </div>-->
        <div class="row">
          <div class="col-12">
            <div>Company Contact Email</div>
            <input
              type="email"
              v-model="value.data.contact_email"
              class="form-control team-form"
              placeholder="Contact Email"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div style="margin-bottom: 5px">Referred By</div>
            <vue-bootstrap-typeahead
              :data="existingRefers"
              v-model="referred_by"
              v-if="value.isShow"
              class="diligenceReferredByClass"
              :serializer="usersSerializer"
              :minMatchingChars="minMatchingChars"
              placeholder="Enter Referred by"
              @hit="onAfterUserSelection"
            >
              <template slot="suggestion" slot-scope="{ data }">
                <div class="d-flex">
                  <div style="padding-top: 6px">
                    {{ data.name }} {{ emailShow(data.email) }}
                  </div>
                </div>
              </template>
            </vue-bootstrap-typeahead>
            <!-- <tags-input
              element-id="tags"
              v-model="referred_by_tags"
              typeahead-style="dropdown"
              ref="tagsRef"
              @change="onChange"
              @blur="onBlur"
              placeholder="Enter Referred by separated by comma"
              :existing-tags="existingRefers"
              :add-tags-on-comma="addTagsOnBlur"
              limit="1"
              :typeahead-max-results="typeMaxResults"
              :case-sensitive-tags="caseSensitiveTags"
              :typeahead="true"
            ></tags-input>-->
          </div>
        </div>
        <!-- <div class="edit-company-action-button-row py-3" style="margin:0px">
          <button
            type="button"
            @click="value.data.isShow=!value.data.isShow"
            class="todo-form-cancel-button btn btn-outline-secondary"
          >Cancel</button>
          <button
            type="button"
            class="btn btn-info btn-fill btn-wd"
            style="height: 35px;"
            :disabled="isSaving"
            @click.prevent="companySave()"
          >
            Save
            <b-spinner v-if="isSaving" style="float: right;" small label="Loading..."></b-spinner>
          </button>
        </div>-->
        <div slot="footer" class="dialog-footer" style>
          <div
            style="
              border: 0.8px solid #ededed;
              opacity: 1;
              margin-top: 18px;
              display: none;
            "
          ></div>
          <div
            class="col-xl edit-company-action-button-row"
            style="padding: 0px; margin-top: 30px"
          >
            <button
              type="button"
              class="todo-form-cancel-button btn-outline-secondary"
              @click="value.isShow = !value.isShow"
            >
              Cancel
            </button>
            <button
              type="button"
              class="todo-form-submit-button btn btn-primary"
              @click.prevent="companySave()"
              :disabled="isSaving || !selected"
            >
              Save
              <b-spinner
                v-if="isSaving"
                style="float: right"
                small
                label="Loading..."
              ></b-spinner>
            </button>
          </div>
        </div>
      </form>
    </el-dialog>
  </div>
</template>
<script>
import VueSingleSelect from "vue-single-select";
import { Dialog } from "element-ui";
import moment from "moment";
import { vals, humanFileSize, cbAdapter } from "../../../util";
import Autocomplete from "vuejs-auto-complete-with-abort";
import { Select, Option } from "element-ui";
const CRUNCHBASE_BASE_URL = "https://api.crunchbase.com/v3.1/";
const CRUNCHBASE_USER_KEY = "f488b788b922f095807326b936073e45";
import TagsInput from "@voerro/vue-tagsinput";
import api from "../../../axios_api";
import { Company } from "../../../models/Company";
import { Portfolio } from "../../../models/Portfolio";
import swal from "sweetalert2";
const DATA_STATUS_UNCONFIRMED = "Unconfirmed";
import VueBootstrapTypeahead from "vue-bootstrap-typeahead";
import { mapGetters } from "vuex";
import config from "../../../../config/settings";
export default {
  components: {
    Autocomplete,
    [Dialog.name]: Dialog,
    [Option.name]: Option,
    [Select.name]: Select,
    TagsInput,
    VueSingleSelect,
    VueBootstrapTypeahead,
  },
  computed: {
    ...mapGetters("referrer", ["teamMembers"]),
    moment() {
      return moment;
    },
    sortedSectors() {
      let sectorList = this.vals.sectorList;
      sectorList.sort((a, b) => a.localeCompare(b));
      return sectorList;
    },
    isShow: {
      get() {
        if (this.value.isShow) {
          this.initializeData();
        }
        return this.value.isShow;
      },
      set(value) {
        this.value.isShow = value;
        if (value) {
          this.isSelected = true;
          this.referred_by = "";
        }
      },
    },
    title: {
      get() {
        return this.value.isCreate ? "Add Diligence" : "Edit Diligence";
      },
    },
  },
  watch: {
    diligenceName: _.debounce(function (addr) {
      if (addr.length > 0) {
        this.getCompanies(addr);
      }
    }, 500),
    referred_by: _.debounce(function (addr) {
      if (addr.length > 0) {
        this.getReferrers(addr);
      }
    }, 500),
    // referred_by_tags: function(data) {
    //   this.$refs.tagsRef.clearInput();
    //   this.referralInput = "";
    // }
  },
  props: {
    value: {
      isShow: Boolean,
      data: Object,
    },
  },
  data() {
    return {
      vals,
      website: "",
      referred_by: "",
      referralInput: "",
      existingRefers: [],
      teams: [],
      referred_by_tags: [],
      isNewCompany: "",
      selected: false,
      addTagsOnBlur: true,
      checkTag: false,
      caseSensitiveTags: false,
      typeMaxResults: 5,
      diligenceName: "",
      minMatchingChars: 1,
      companiesList: [],
      isSelected: false,
      isSaving: false,
    };
  },
  mounted() {},
  methods: {
    emailShow(item) {
      let itemEmail = item ? `<${item}>` : "";
      return itemEmail;
    },
    initializeData() {
      this.teams =
        this.teamMembers && this.teamMembers.length > 0
          ? JSON.parse(JSON.stringify(this.teamMembers))
          : [];
      this.teams.map((item) => {
        item.isTeam = true;
      });
    },
    onAfterUserSelection(selectedValue) {
      if (selectedValue && selectedValue.isTeam) {
        this.value.data.referred_by = [
          {
            key: selectedValue.account._id,
            isTeam: true,
            value: selectedValue.name,
          },
        ];
      } else {
        this.value.data.referred_by = [
          {
            key: selectedValue._id,
            isTeam: false,
            value: selectedValue.name,
          },
        ];
      }
      this.isSelected = true;
      this.referred_by = "";
    },
    usersSerializer(data) {
      return data.name;
    },
    onBlur() {
      self.setTimeout(() => {
        if (this.referralInput) {
          let tag = { key: "", value: this.referralInput };
          if (this.referred_by_tags && this.referred_by_tags.length > 0)
            this.referred_by_tags.push(tag);
          else this.referred_by_tags = [tag];
          this.$refs.tagsRef.clearInput();
        }
      }, 10);
    },
    onTagAdded(tag) {
      let self = this;
      if (self.checkTag) {
        if (tag.value == self.referralInput) {
          tag.isRemove = true;
        }
      }
    },
    setValue(data) {
      let self = this;
      self.$refs.autocomplete.display = data;
      self.value.data.name = data;
    },
    companySave() {
      this.isSaving = true;
      this.value.data.direct = "Direct";
      this.value.data.value = 0;
      this.value.data.cost = 0;
      let companyProfile;
      if (!this.isSelected && this.referred_by.length > 0) {
        this.value.data.referred_by = [
          {
            key: "",
            isTeam: false,
            value: this.referred_by,
          },
        ];
      }
      if (this.value.data && this.value.data.permalink) {
        // this.value.data.referred_by = this.referred_by_tags;
        let companies = this.$store.getters["portfolio/portfolioAll"];
        let check = companies.find(
          (company) => company.permalink == this.value.data.permalink
        );
        if (check) {
          let msg =
            check &&
            check.user_investment_status &&
            check.user_investment_status == "Invested"
              ? "Company already exists in portfolio."
              : "Company already exists.";
          this.$toaster.error(msg);
          this.isSaving = false;
          return;
        }
        companyProfile = _.cloneDeep(this.value.data);
      } else {
        let companies = this.$store.getters["portfolio/portfolioAll"];
        let check = companies.find(
          (company) => company.name == this.diligenceName
        );
        if (check) {
          let msg =
            check &&
            check.user_investment_status &&
            check.user_investment_status == "Invested"
              ? "Company already exists in portfolio."
              : "Company already exists.";
          this.$toaster.error(msg);
          this.isSaving = false;
          return;
        }
        this.value.data.properties = {};
        this.value.data.properties.name = this.diligenceName;
        // this.value.data.name = this.diligenceName;
        this.value.data.current_stage = "Pre-Seed";
        this.value.data.data_status = "Confirmed";
        this.value.data.status = "Unknown";
        companyProfile = _.cloneDeep(this.value.data);
      }
      let portfolioInfo = {};
      let companyWriteResponse = null;
      let createdCompany = false;
      let company = new Company(companyProfile);
      let portfolio = new Portfolio({});
      if (this.value.data.contact_email) {
        let emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
        let check = emailPattern.test(this.value.data.contact_email);
        if (!check) {
          this.$toaster.error("Please enter a vaild Contact Email");
          this.isSaving = false;
          return;
        }
      }
      return company
        .validate()
        .then((res) => {
          return company.writeToDiligenceServer();
        })
        .then((res) => {
          companyWriteResponse = res;
          // set our portfolio company id to the company instance
          createdCompany = true;
          portfolio.company = company._id;
          portfolio.org_company_id = company._id;
          if (
            this.value.data &&
            this.value.data.referred_by &&
            this.value.data.referred_by.length
          )
            this.$store.dispatch("referrer/start");
        })
        .then((res) => {
          // mark as retrieving
          if (
            !companyWriteResponse ||
            companyWriteResponse.data_status == DATA_STATUS_UNCONFIRMED
          ) {
            let url = `${this.$route.params.account_id}/${this.$route.params.workspace_id}/company/confirm`;

            return api.post(url, {
              encrypt: {
                data: {
                  company: portfolio,
                  confirmedCompany: companyProfile.cb_data,
                },
              },
            });
          } else {
            return Promise.resolve(this);
          }
        })
        .then((res) => {
          // need to reload our portfolio info
          this.$store.dispatch("contacts/getContacts");
          return this.$store
            .dispatch("portfolio/_apiFetchPortfolio")
            .then((data) => {
              this.$toaster.success("Successfully Created Company.");
              this.value.isShow = false;
              this.isSaving = false;
              this.$emit("success-emit");
            })
            .catch((err) => {
              console.log({ err });
            });
        })
        .catch((err) => {
          this.isSaving = false;
          console.log(`err: ${JSON.stringify(err)}`);
          this.value.isShow = false;
          if (!_.isNil(err.errors) && !_.isNil(err.type)) {
            // validation errors, create html for swal
            this.$toaster.error(`Server Validation Errors`);
          } else if (!_.isNil(err.errors)) {
            this.$toaster.error(`Server Validation Errors`);
          } else {
            // error (prob from the server)
            let text = !_.isNil(err.error) ? err.error : "";
            if (text.includes("already exists"))
              this.$toaster.success("Company already exists in Portfolio.");
            else this.$toaster.error(`Unable to Create Company:${text}`);
          }
        });
    },
    resultsFormatter(input) {
      return input.data.items.map((item) => {
        return { id: item.uuid, name: item.properties.name, raw: item };
      });
    },
    onChange(value) {
      let self = this;
      self.referralInput = value;
      api
        .get(`/attributors/${self.$route.params.workspace_id}/${value}`)
        .then((data) => {
          self.existingRefers = [];
          data.data.encrypt.data.map((item) => {
            let json = {};
            json.key = item._id;
            json.value = item.name.charAt(0).toUpperCase() + item.name.slice(1);
            self.existingRefers.push(json);
          });
        })
        .catch((err) => {
          console.log("error", err);
        });
    },
    handleCancel() {
      self.$refs.autocomplete.display = "";
    },
    onTagsUpdated() {
      let index = this.value.data.referred_by.findIndex(
        (item) => item.value == this.referralInput && item.isRemove
      );
      if (index >= 0) {
        this.value.data.referred_by.splice(index, 1);
        this.referralInput = "";
      }
    },
    
    getReferrers() {
      let self = this;
      api
        .get(
          `/attributors/${self.$route.params.workspace_id}/${self.referred_by}`
        )
        .then((resp) => {
          self.existingRefers = [];
          self.existingRefers = [...self.teams, ...resp.data.encrypt.data];
        })
        .catch((err) => {
          console.log("error", err);
        });
    },
    async getCompanies(query) {
      this.isNewCompany = false;
      this.selected = false;
      
      const response = await api.get(`search?key=${query}`);

      const suggestions = cbAdapter(response);

      if (suggestions.data.items && suggestions.data.items.length > 0)
        this.companiesList = suggestions.data.items;
      else {
        this.companiesList = [
          {
            properties: {
              name: this.diligenceName,
              short_description: "No results Found. Continue..",
            },
          },
        ];
      }
    },
    checkCompany(item) {
      let companies = this.$store.getters["portfolio/portfolioAll"];
      let check;
      if (item.properties.permalink) {
        check = companies.filter(
          (company) =>
            item.properties.permalink &&
            company.permalink == item.properties.permalink
        );
      } else {
        check = companies.filter(
          (company) =>
            item.properties.name && company.name == item.properties.name
        );
        if (check && check.length > 0)
          item.properties.short_description = "Company already exists";
      }
      if (check && check.length > 0) item.duplicate = "found";
      return item.properties.name;
    },
    formattedDisplay(result) {
      return result.name;
    },
    onAfterCompanySelection(selectedValue) {
      let self = this;
      self.selected = true;
      self.diligenceName = "";
      if (
        selectedValue.properties.short_description ==
        "No results Found. Continue.."
      )
        self.isNewCompany = true;

      self.value.data.name = selectedValue.properties.name;
      self.value.data.geography = selectedValue.properties.city_name;
      self.value.data.website = selectedValue.properties.homepage_url;
      self.value.data.facebook = selectedValue.properties.facebook_url;
      self.value.data.linkedin = selectedValue.properties.linkedin_url;
      self.value.data.twitter = selectedValue.properties.twitter_url;
      self.value.data.logo_url = selectedValue.properties.profile_image_url;
      self.value.data.permalink = selectedValue.properties.permalink;
      self.value.data.cb_data = selectedValue;
    },
    resultsDisplay(result) {
      let companies = this.$store.getters["portfolio/portfolioData"];

      let found = _.find(companies, function (item) {
        return item.permalink == result.raw.properties.permalink;
      });
      if (result)
        return `<div class="${found ? "duplicate" : ""}">
        <div class=" dd-icon-wrapper">
        <img class="dd-icon" src="${result.raw.properties.profile_image_url}">
        </div>
        ${result.name}
        <span class="gray">${result.raw.properties.short_description}</span>
        <span class="exists">already exists in your portfolio</span>
        </div>`;
      else {
        return `No result Found.Add ${this.value.data.name}`;
      }
    },
    getImageUrl(image) {
      if (!image) {
        return;
      }
      // image.includes(
      //  "https://res-3.cloudinary.com/crunchbase-production/image/upload"
      //) ||
      if (
        image.includes(config.CRUNCHBASE_IMAGE_URL) ||
        image.includes("https://res") ||
        image.includes("static/img/generic-logo.png")
      ) {
        return image;
      }
      let imageId = image.slice(image.lastIndexOf("t_api_images/") + 13);
      if (!imageId || imageId.length == 0) {
        return image;
      }
      return `${config.CRUNCHBASE_IMAGE_URL}/${imageId}`;
    },

    addAnyway(param) {
      let self = this;
      self.selected = true;

      self.isNewCompany = true;

      self.value.data.name = self.diligenceName;
      self.value.data.geography = "";
      self.value.data.website = "";
      self.value.data.facebook = "";
      self.value.data.linkedin = "";
      self.value.data.twitter = "";
      self.value.data.logo_url = "";
      self.value.data.permalink = "";
      self.value.data.cb_data = "";
    },
  },
};
</script>
<style>
.autocomplete__box {
  background: #ffffff 0% 0% no-repeat padding-box !important;
  border: 1px solid #868686 !important;
  border-radius: 4px !important;
}

.diligence-dialog .el-dialog .el-dialog__header {
  padding-left: 41px;
  padding-top: 25px;
  padding-bottom: 25px;
  /* border-bottom: 0.8px solid #ededed; */
}

.diligence-dialog .el-dialog .el-dialog__header .el-dialog__title {
  font-size: 24px;
}

.diligence-dialog .el-dialog .el-dialog__body {
  padding-left: 40px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
  padding-right: 40px;
  padding-top: 5px;
  padding-bottom: 30px;
}

.diligenceAutoCompleteClass .vbst-item {
  padding-top: 2px;
  padding-bottom: 2px;
}

.diligenceReferredByClass .vbst-item {
  text-transform: initial !important;
}

/* .vbt-autcomplete-list {
  overflow: hidden !important;
} */
/* .diligenceAutoCompleteClass .vbt-autcomplete-list{
  min-height: 5px;
  height: 500px;
  overflow-y: auto;
} */
</style>